import { createRoute, Outlet } from "@tanstack/react-router"

import { OrgRoute } from "@/routes/root/RootRoute.tsx"
import { SandboxScene } from "@/routes/sandbox/SandboxScene.tsx"

export const SandboxRoute = createRoute({
  path: "sandbox",
  component: () => <Outlet />,
  getParentRoute: () => OrgRoute,
})

export const SandboxRouteIndex = createRoute({
  path: "/",
  component: () => <SandboxScene />,
  getParentRoute: () => SandboxRoute,
})

